import { isEnabled } from '@client/monolith/legacy/services/features';
import store from '@client/monolith/legacy/store';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export const useAgent = () => {
  const route = useRoute();
  // hardcoded list of routes where the agent is enabled until another needed
  const ValidRoutes = [
    'connected',
    'search',
    'boutique',
    'category',
    'brand',
    'product',
    'mylist',
    'collection',
    'catalogEvent',
    'new',
  ];

  const isLoggedIn = computed(() => store.getters['isUserAuthenticated']);

  const agentEnabled = computed(() => {
    return ValidRoutes.includes(route.name as string) && isEnabled('search-ai-plugin') && isLoggedIn.value;
  });

  return {
    agentEnabled,
  };
};
